/* Отправка итога «Сменить голос в записи» / «Почистить запись» по кнопке (deliver: on_request, 03-api.md §12.4) в React:
   тонкий хук над ядром voice-delivery.ts — тот же код отправки, что у экрана движка.
   В отличие от общего useCircleDelivery здесь два способа отправки одной работы: отправленное голосовым не мешает отправить файлом.
   Ядро — одно на заказ (новый orderId — новое ядро); сведения видны только при ready, отметки отправки и ход отправки — всегда. */
import { useEffect, useReducer, useState } from 'react';
import { createVoiceDelivery } from './voice-delivery';
import type { VoiceOut } from './voice-model';

const OUTS: readonly VoiceOut[] = ['voice', 'file'];

export function useVoiceDelivery(orderId: number, ready: boolean) {
  /* каждое изменение ядра — новый рендер; ядро само хранит своё состояние */
  const [, changed] = useReducer((value: number) => value + 1, 0);
  const [box, setBox] = useState(() => ({ orderId, core: createVoiceDelivery(orderId, { changed }) }));
  let core = box.core;
  if (box.orderId !== orderId) {
    /* у другого заказа нет ни сведений, ни отметок прежнего */
    core = createVoiceDelivery(orderId, { changed });
    setBox({ orderId, core });
  }
  useEffect(() => {
    if (!ready || !orderId) return;
    const request = new AbortController();
    void core.load(request.signal);
    return () => request.abort();
  }, [core, orderId, ready]);
  const detail = ready ? core.detail() : null;
  const sent: Partial<Record<VoiceOut, boolean>> = {};
  for (const out of OUTS) if (core.sent(out)) sent[out] = true;
  return {
    detail,
    error: core.error(),
    busy: core.busy(),
    sent,
    /** Есть ли у заказа этот способ отправки */
    can: (out: VoiceOut) => !!detail && core.can(out),
    send: async (out: VoiceOut) => (detail ? core.send(out) : false),
  };
}
